"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleKlarnaResponse = void 0;
const handleKlarnaResponse = (data, dataClientId) => {
  return data.content.nodes?.reduce((res, {
    name,
    value,
    label,
    url,
    klarnaAlt,
    alt
  }) => {
    switch (name) {
      case 'TEXT_MAIN':
        res.klarnaDescription = value;
        break;
      case 'ACTION_LEARN_MORE':
        res.learnMoreText = label;
        res.learnMoreUrl = url;
        break;
      case 'KLARNA_O':
        res.klarnaImage = url;
        res.klarnaAltText = klarnaAlt;
        break;
      case 'KLARNA_BADGE':
        res.klarnaImage = url;
        res.klarnaAltText = alt;
        break;
      default:
        break;
    }
    return res;
  }, {
    dataClientId: dataClientId,
    klarnaImpression: data.impression_url
  });
};
exports.handleKlarnaResponse = handleKlarnaResponse;